const { REACT_APP_ASSIST_API_URL, REACT_APP_ASSIST_API_TOKEN } = process.env;

export const submitPrivacyAgreeApi = () => {
  return {
    headers: {
      emquest_access_token: REACT_APP_ASSIST_API_TOKEN,
    },
    apiUrl: REACT_APP_ASSIST_API_URL + `/system/agree_privacy_terms`,
  };
};
